/**
 * Tela de entrada: aparece em todo carregamento do app pelo endereco principal
 * (`/`) e sai pelo botao "Entrar". Link direto (uma ficha, um laudo) abre a
 * pagina sem ela.
 *
 * `equiview.entrada = 'pular'` no localStorage existe so para as ferramentas
 * (auditoria de layout, testes): a pessoa nunca ve nem grava essa chave.
 */
const CHAVE = 'equiview.entrada';

export function deveMostrarEntrada(pathname: string, storage: Pick<Storage, 'getItem'> | null): boolean {
  if (pathname !== '/') return false;
  try {
    return storage?.getItem(CHAVE) !== 'pular';
  } catch {
    // Armazenamento bloqueado: mostra a entrada, que e o padrao.
    return true;
  }
}
